import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

// Fetch total unique surname count
export const fetchTotalVillageCount = createAsyncThunk(
  "data/fetchTotalVillageCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/admin/dataCount/get_totalVillageCount`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch total active members count
export const fetchTotalMemberList = createAsyncThunk(
  "data/fetchTotalMemberList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/admin/dataCount/get_totalMemberList`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch total active categories count
export const fetchTotalCategory = createAsyncThunk(
  "data/fetchTotalCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/admin/dataCount/get_totalCategory`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch total active media count (Gallery + Videos)
export const fetchTotalMedia = createAsyncThunk(
  "data/fetchTotalMedia",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/admin/dataCount/get_totalMedia`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch total active media count (Gallery + Videos)
export const fetchTotalOnlineUser = createAsyncThunk(
  "data/fetchTotalOnlineUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/admin/dataCount/get_totalOnlineUser`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
